import { auth, db } from 'config/firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';

/**
 * Utilidad para crear un usuario administrador
 * SOLO USAR EN DESARROLLO - ELIMINAR EN PRODUCCIÓN
 */

export const createAdminUser = async (email: string, password: string, name: string) => {
  try {
    console.log('🔧 Creando usuario administrador...');
    
    // 1. Crear usuario en Firebase Auth
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    
    console.log('✅ Usuario creado en Auth:', user.uid);
    
    // 2. Crear documento de usuario en Firestore con role='admin'
    const userData = {
      uid: user.uid,
      email: user.email,
      name: name,
      role: 'admin', // ⭐ IMPORTANTE: Esto hace al usuario administrador
      isActive: true,
      createdAt: new Date(),
      updatedAt: new Date(),
      lastLogin: new Date(),
      emailVerified: false,
      profile: {
        firstName: name.split(' ')[0] || name,
        lastName: name.split(' ').slice(1).join(' ') || '',
        phone: '',
        avatar: '',
      },
      preferences: {
        language: 'es',
        notifications: true,
        theme: 'light',
      },
      stats: {
        webIDsCreated: 0,
        totalScans: 0,
        lastActivity: new Date(),
      }
    };
    
    await setDoc(doc(db, 'users', user.uid), userData);
    
    console.log('✅ Usuario administrador creado exitosamente');
    console.log('📧 Email:', email);
    console.log('🔑 UID:', user.uid);
    console.log('👑 Role: admin');
    
    return {
      success: true,
      uid: user.uid,
      email: user.email,
      message: 'Usuario administrador creado exitosamente'
    };
    
  } catch (error: unknown) {
    console.error('❌ Error creando usuario administrador:', error);

    return {
      success: false,
      error: (error as Error).message,
      message: 'Error al crear usuario administrador'
    };
  }
};

/**
 * Función para ejecutar desde la consola del navegador
 * Abre las DevTools y ejecuta:
 * 
 * window.createAdminUser('admin@nfcores.com', 'Admin123!', 'Administrador Principal')
 */
if (typeof window !== 'undefined') {
  (window as typeof window & { createAdminUser: typeof createAdminUser }).createAdminUser = createAdminUser;
}

// Ejemplo de uso:
// createAdminUser('admin@nfcores.com', 'Admin123!', 'Administrador Principal');
